<template>
  <!-- 联系我们 -->
  <div class="w-full relative title-family-normal">
    <!-- 背景图 -->
    <div class="absolute inset-0 w-full h-full">
      <img
        :src="homeBottomImg"
        alt="contactUs"
        class="w-full h-full object-cover"
      />
    </div>

    <!-- 内容层 -->
    <div class="relative z-10 flex flex-col items-center justify-center py-8 sm:py-12 md:py-16 lg:py-20 px-4 sm:px-6 min-h-[600px] sm:min-h-[700px] md:min-h-[800px]">
      <!-- 中间：线下体验 Contact US -->
      <img
        :src="contactImg"
        alt="home_bottom_center"
        class="h-auto w-[90%] sm:w-auto scroll-fade-in max-w-[80px] sm:max-w-[100px] md:max-w-[122px] lg:max-w-[144px] mb-6 sm:mb-8 md:mb-10"
      >

      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-[50px] items-start md:items-center justify-center mt-4 sm:mt-6 md:mt-[50px] w-full max-w-[1400px]">
        <!-- 左侧联系信息 -->
        <div class="flex flex-col gap-4 sm:gap-5 md:gap-6 w-full scroll-fade-in-left">
          <!-- 联系电话 -->
          <div class="flex flex-col">
            <div class="text-[#333333] text-[14px] sm:text-[16px] md:text-[20px] lg:text-[20px] mb-[6px] title-family-normal font-normal">联系电话:</div>
            <a
              href="tel:13052585965"
              class="text-[#000000] text-[18px] sm:text-[20px] md:text-[24px] lg:text-[24px] font-bold hover:opacity-80 transition-opacity"
            >130 5258 5965</a>
          </div>

          <!-- 联系地址 -->
          <div class="flex flex-col">
            <div class="text-[#333333] text-[14px] sm:text-[16px] md:text-[20px] lg:text-[20px] mb-[6px] title-family-normal font-normal">联系地址:</div>
            <div class="text-[#000000] text-[16px] sm:text-[18px] md:text-[22px] lg:text-[24px] font-bold leading-tight break-words">上海市闵行区万芳路515号A座8层</div>
          </div>

          <!-- 二维码 -->
          <div class="flex flex-row gap-4 sm:gap-5 md:gap-6 mt-4 sm:mt-5 justify-center md:justify-start">
            <div class="flex flex-col items-center">
              <div class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[120px] md:h-[120px] lg:w-[140px] lg:h-[140px] bg-white rounded-lg mb-2 flex items-center justify-center shadow-md">
                <!-- 二维码占位，实际使用时替换为真实二维码图片 -->
                <img
                  :src="productCodeImg"
                  alt="产品支持二维码"
                  class="w-full h-full object-contain"
                />
              </div>
              <div class="text-[#000000] text-[12px] sm:text-[14px] md:text-[18px] lg:text-[24px] font-bold title-family-normal">产品支持</div>
            </div>
            <div class="flex flex-col items-center">
              <div class="w-[80px] h-[80px] sm:w-[100px] sm:h-[100px] md:w-[120px] md:h-[120px] lg:w-[140px] lg:h-[140px] bg-white rounded-lg mb-2 flex items-center justify-center shadow-md">
                <!-- 二维码占位，实际使用时替换为真实二维码图片 -->
                <img
                  :src="coopCodeImg"
                  alt="合作咨询二维码"
                  class="w-full h-full object-contain"
                />
              </div>
              <div class="text-[#000000] text-[12px] sm:text-[14px] md:text-[18px] lg:text-[24px] font-bold title-family-normal">合作咨询</div>
            </div>
          </div>
        </div>

        <!-- 右侧：地图和地址 -->
        <div class="flex flex-col gap-4 w-full scroll-fade-in-right">
          <!-- 地图容器 -->
          <div class="w-full max-w-[600px] mx-auto h-[250px] sm:h-[300px] md:h-[350px] lg:h-[400px] bg-white rounded-lg overflow-hidden shadow-lg relative">
            <!-- 使用高德地图组件 -->
            <AmapMap
              :longitude="121.404"
              :latitude="31.081"
              address="上海市闵行区 万芳路515号"
              :zoom="16"
              :height="'100%'"
              :show-marker="true"
              marker-title="易目秀信息科技(上海)有限公司"
            />
            <!-- 地图上的地址标记 -->
            <div class="absolute bottom-0 left-0 right-0 bg-[#333333]/20 backdrop-blur-md text-black text-[12px] sm:text-[14px] md:text-[18px] lg:text-[24px] px-2 sm:px-[29px] py-1.5 sm:py-4 text-left z-10 font-bold">
              上海市闵行区万芳路515号A座8层
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount } from "vue";
import AmapMap from "@/components/AmapMap.vue";
import homeBottomImg from "@/assets/img/home_bottom.webp";
import contactImg from "@/assets/img/contact.webp";
import productCodeImg from "@/assets/img/product-code.webp";
import coopCodeImg from "@/assets/img/coop-code.webp";

// 存储已触发动画的元素
const animatedElements = new Set<HTMLElement>();

// Intersection Observer 配置
const observerOptions: IntersectionObserverInit = {
  root: null,
  rootMargin: "0px",
  threshold: 0.1, // 当元素10%可见时触发
};

// 创建 Intersection Observer
let observer: IntersectionObserver | null = null;

onMounted(() => {
  // 创建 observer
  observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (
        entry.isIntersecting &&
        !animatedElements.has(entry.target as HTMLElement)
      ) {
        // 元素进入视口且未触发过动画
        const element = entry.target as HTMLElement;
        // 检查元素是否已经在视口中（初始可见）
        const rect = element.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
        
        if (isVisible) {
          // 如果元素已经在视口中，立即应用动画
          element.classList.add("fade-in-visible");
          animatedElements.add(element);
        } else {
          // 否则等待 observer 触发
          element.classList.add("fade-in-visible");
          animatedElements.add(element);
        }
      }
    });
  }, observerOptions);

  // 观察所有带有滚动动画类的元素
  const elements = document.querySelectorAll(
    ".scroll-fade-in, .scroll-fade-in-left, .scroll-fade-in-right"
  );
  elements.forEach((element) => {
    // 检查元素是否已经在视口中
    const rect = element.getBoundingClientRect();
    const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
    
    if (isVisible && !animatedElements.has(element as HTMLElement)) {
      // 如果元素已经在视口中，立即应用动画
      (element as HTMLElement).classList.add("fade-in-visible");
      animatedElements.add(element as HTMLElement);
    } else if (observer) {
      // 否则开始观察
      observer.observe(element);
    }
  });
});

onBeforeUnmount(() => {
  if (observer) {
    observer.disconnect();
  }
});
</script>

<style scoped>
/* 组件样式 */
.title-family-normal {
  font-family: "Noto Sans SC";
}

/* 滚动动画效果 - 小元素从底部飞入 */
.scroll-fade-in {
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

/* 滚动动画效果 - 从左边飞入 */
.scroll-fade-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-left.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}

/* 滚动动画效果 - 从右边飞入 */
.scroll-fade-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.scroll-fade-in-right.fade-in-visible {
  opacity: 1;
  transform: translateX(0);
}
</style>

